export const getColumnIndex = (letter: string) => {
  return letter.charCodeAt(0) - "A".charCodeAt(0);
};

export const getColumnLetter = (index: number) => {
  return String.fromCharCode(index + "A".charCodeAt(0));
};
